import {ComponentData} from "../../engine/tools/EntityManager";

export class BaseLevel implements ComponentData {
    baseLevel:number = 0;
    collisionSound
    isColliding :number = 0
    collisionVelocity :number= 0

    constructor(options?: Partial<BaseLevel>) {
        Object.assign(this, options)
    }
}